import React, { FC, useEffect, useState } from "react";
import Modal from "../common/modal";
import Input from "../common/input";
import Title from "../common/title";
import Button from "../common/button";
import { Props as ReactModalProps } from "react-modal";
import * as globalConstants from "../../constants/global.constants";
import * as constants from "../../constants/fixture.constants";
import { optaIdError } from "./validation";

import styles from "./setOptaIdModal.module.scss";

export interface SetOptaIdModalProps extends ReactModalProps {
    isOpen: boolean;
    title: string;
    optaId?: string;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: (optaId: string) => void;
}

const SetOptaIdModal: FC<SetOptaIdModalProps> = ({ isOpen, title, optaId, loading, onCancel, onConfirm, ...rest }) => {
    const [value, setValue] = useState(optaId || "");

    useEffect(() => {
        if (isOpen) setValue(optaId || "");
    }, [isOpen, optaId]);

    const error = optaIdError(value);

    const handleChange = ({ currentTarget: input }: { currentTarget: any }) => setValue(input.value);

    const handleConfirm = () => onConfirm(value.trim());

    return (
        <Modal {...rest} isOpen={isOpen} className={styles.modal}>
            <div className={styles.content}>
                <Title label={constants.SET_OPTA_ID} classes={`subtitle ${styles.subtitle}`}></Title>
                <Title label={title} classes={`subtitle ${styles.subtitle}`}></Title>
                <Title
                    label={constants.OPTA_ID_CURRENT.replace("{value}", optaId || constants.OPTA_ID_NOT_SET)}
                    classes={styles.current}
                ></Title>
                <Input
                    id={constants.OPTA_ID}
                    label={constants.OPTA_ID}
                    value={value}
                    classes={styles.inputContainer}
                    errorClasses={styles.inputError}
                    onChange={handleChange}
                    error={error}
                />
            </div>
            <div className={styles.confirmParentContainer}>
                <div className={styles.confirmChildContainer}>
                    <Button
                        id={globalConstants.CANCEL}
                        name={globalConstants.CANCEL}
                        classes={`btn-outline-green m-0 ${styles.cancelButton}`}
                        onClick={onCancel}
                    ></Button>
                    <Button
                        id={globalConstants.CONFIRM}
                        name={globalConstants.CONFIRM}
                        classes={"btn-green m-0"}
                        onClick={handleConfirm}
                        disabled={error !== "" || !!loading}
                    ></Button>
                </div>
            </div>
        </Modal>
    );
};

export default SetOptaIdModal;
